module.exports = __webpack_public_path__ + "static/img/title-icon.79702488.png";